<!-- LEGACY -->

<div class="container store-level "
    [ngClass]="{'ace-store': globals.storeSettings && globals.storeSettings.type == 'ace', 'partner-store': globals.storeSettings && globals.storeSettings.type == 'partner', 'new-font':globals.currentUser, 'partner-themed':globals.currentUser}">
    <br />
    <div class="row" *ngIf="!globals.currentUser">
        <div class="col">
            <h1 *ngIf="globals.storeSettings" class="capitalize">{{globals.storeSettings.name}}</h1>
        </div>
        <div class="col align-right">
            <h5 class="clickable" [routerLink]="[globals.panelUrl('/credit-transactions')]"
                *ngIf="globals.storeSettings && globals.storeSettings.type == 'partner'">{{ 'Krediter' | translate }}:
                {{utility.numberFormat(globals.storeSettings.credits)}}</h5>
        </div>
    </div>

    <div class="row" *ngIf="globals.currentUser">
        <div class="col">
            <img src="/gateway-app/browser/assets/ace-logo-white.png" class="logo" />
        </div>
        <div class="col align-right">
            <div>
                <h4>{{globals.storeSettings.name}}</h4>
                <h6 class="clickable" [routerLink]="[globals.panelUrl('/credit-transactions')]"
                    *ngIf="globals.storeSettings && globals.storeSettings.type == 'partner'">{{ 'Saldo' | translate }}:
                    {{utility.numberFormat(globals.storeSettings.credits)}}</h6>
                <button mat-stroked-button class="add-credits-btn"
                    [routerLink]="[globals.panelUrl('/credit-transactions')]"
                    *ngIf="globals.storeSettings && globals.storeSettings.type == 'partner' && globals.storeSettings.platform === 'shopify'">
                    {{ 'Add credits' | translate }}
                </button>
            </div>


        </div>
    </div>

    <div class="menu" *ngIf="globals.storeSettings && !globals.currentUser">
        <div class="row">
            <div class="col-auto" *ngIf="globals.adminKey">
                <button mat-menu-item class="partner-store-admin-color" [routerLink]="[globals.panelUrl('/store-settings')]">
                    <span class="material-symbols-outlined partner-store-admin-color">settings</span>
                    <span>{{ 'Inställningar' | translate }}</span>
                </button>
            </div>
            <!--  <div class="col-auto">
        <button mat-menu-item [routerLink]="[globals.panelUrl('/orders')]">
          <span class="material-symbols-outlined">storefront</span>
          <span>{{ 'Shopify-ordrar' | translate }}</span>
        </button>
      </div> -->
            <div class="col-auto" *ngIf="globals.adminKey">
                <button mat-menu-item class="partner-store-admin-color" [routerLink]="[globals.panelUrl('/print-files')]">
                    <span class="material-symbols-outlined partner-store-admin-color">wallpaper</span>
                    <span>{{ 'Tryckfiler' | translate }}</span>
                </button>
            </div>
            <div class="col-auto">
                <button mat-menu-item [routerLink]="[globals.panelUrl('/posters')]">
                    <span class="material-symbols-outlined">wall_art</span>
                    <span>{{ 'Produkter' | translate }}</span>
                </button>
            </div>
            <div class="col-auto">
                <button mat-menu-item [routerLink]="[globals.panelUrl('/poster-orders')]">
                    <span class="material-symbols-outlined">paid</span>
                    <span>{{ 'Ordrar' | translate }}</span>
                </button>
            </div>
            <div class="col-auto" *ngIf="globals.adminKey || globals.storeSettings.enabledFeatures.tools">
                <button mat-menu-item [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.tools}" [matMenuTriggerFor]="tools">
                    <span class="material-symbols-outlined" [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.tools}">construction</span>
                    <span>{{ 'Verktyg' | translate }}</span>
                </button>
            </div>
        </div>
        <br />




        <mat-menu #tools="matMenu">
            <button mat-menu-item *ngIf="globals.adminKey || globals.storeSettings.enabledFeatures.createOrder"
                [routerLink]="[globals.panelUrl('/create-order')]">
                <span class="material-symbols-outlined" [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.createOrder, 'partner-color': globals.storeSettings.enabledFeatures.createOrder}">add</span>
                <span class="" [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.createOrder, 'partner-color': globals.storeSettings.enabledFeatures.createOrder}">{{ 'Skapa order' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/barcode-generator')]">
                <span class="admin-color material-symbols-outlined">barcode</span>
                <span class="admin-color">{{ 'Skapa barcode' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/barcode-tester')]">
                <span class="admin-color material-symbols-outlined">check</span>
                <span class="admin-color">{{ 'Testa barcode' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/image-generator')]">
                <span class="admin-color material-symbols-outlined">neurology</span>
                <span class="admin-color">{{ 'Generera bilder' | translate }}</span>
            </button>
            <button mat-menu-item [routerLink]="[globals.panelUrl('/credit-transactions')]">
                <span class="partner-color material-symbols-outlined">wallet</span>
                <span class="partner-color">{{ 'Debiteringar' | translate }}</span>
            </button>
        </mat-menu>

        <mat-menu #stores="matMenu" *ngIf="globals.stores && globals.stores.length > 1">
            <button mat-menu-item *ngFor="let store of globals.stores" [routerLink]="[globals.panelUrl('/store/' + store._id)]">
                <span class="">{{store.name}}</span>
            </button>
        </mat-menu>
    </div>


    <div class="menu" *ngIf="globals.storeSettings && globals.currentUser">
        <div class="row">
            <div class="col-auto" *ngIf="globals.currentUser.role == 'ACE'">
                <button mat-menu-item class="partner-store-admin-color" [routerLink]="[globals.panelUrl('/store-settings')]">
                    <span class="material-symbols-outlined partner-store-admin-color">settings</span>
                    <span>{{ 'Inställningar' | translate }}</span>
                </button>
            </div>
            <div class="col-auto" *ngIf="globals.currentUser.role == 'ACE'">
                <button mat-menu-item class="partner-store-admin-color" [routerLink]="[globals.panelUrl('/print-files')]">
                    <span class="material-symbols-outlined partner-store-admin-color">wallpaper</span>
                    <span>{{ 'Tryckfiler' | translate }}</span>
                </button>
            </div>
            <div class="col-auto">
                <button mat-menu-item [routerLink]="[globals.panelUrl('/posters')]">
                    <span class="material-symbols-outlined">wall_art</span>
                    <span>{{ 'Produkter' | translate }}</span>
                </button>
            </div>
            <div class="col-auto">
                <button mat-menu-item [routerLink]="[globals.panelUrl('/poster-orders')]">
                    <span class="material-symbols-outlined">paid</span>
                    <span>{{ 'Ordrar' | translate }}</span>
                </button>
            </div>
            <div class="col-auto" *ngIf="globals.currentUser.role == 'ACE' || globals.storeSettings.enabledFeatures.tools">
                <button mat-menu-item [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.tools}" [matMenuTriggerFor]="toolsMenu">
                    <span class="material-symbols-outlined" [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.tools}">construction</span>
                    <span>{{ 'Verktyg' | translate }}</span>
                </button>
            </div>


            <div class="col-auto" *ngIf="globals.stores && globals.stores.length > 1">
                <button mat-menu-item [matMenuTriggerFor]="storesMenu">
                    <span class="material-symbols-outlined">storefront</span>
                    <span>{{ 'Butiker' | translate }}</span>
                </button>
            </div>
        </div>
        <br />




        <mat-menu #toolsMenu>
            <button mat-menu-item *ngIf="globals.adminKey || globals.storeSettings.enabledFeatures.createOrder"
                [routerLink]="[globals.panelUrl('/create-order')]">
                <span class="material-symbols-outlined" [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.createOrder, 'partner-color': globals.storeSettings.enabledFeatures.createOrder}">add</span>
                <span class="" [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.createOrder, 'partner-color': globals.storeSettings.enabledFeatures.createOrder}">{{ 'Skapa order' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/barcode-generator')]">
                <span class="admin-color material-symbols-outlined">barcode</span>
                <span class="admin-color">{{ 'Skapa barcode' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/barcode-tester')]">
                <span class="admin-color material-symbols-outlined">check</span>
                <span class="admin-color">{{ 'Testa barcode' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/image-generator')]">
                <span class="admin-color material-symbols-outlined">neurology</span>
                <span class="admin-color">{{ 'Generera bilder' | translate }}</span>
            </button>
            <button mat-menu-item [routerLink]="[globals.panelUrl('/credit-transactions')]">
                <span class="partner-color material-symbols-outlined">wallet</span>
                <span class="partner-color">{{ 'Debiteringar' | translate }}</span>
            </button>
        </mat-menu>

        <mat-menu #storesMenu *ngIf="globals.stores && globals.stores.length > 1">
            <button mat-menu-item *ngFor="let store of globals.stores">
                <span class="">{{store.name}}</span>
            </button>
        </mat-menu>
    </div>

    <div *ngIf="globals.storeSettings">
        <router-outlet></router-outlet>
    </div>
</div>